export const capitalize = (string: string) => {
  if (!string) return '';
  return string[0].toUpperCase() + string.substring(1).toLowerCase();
};

export const capitalizeWords = (string: string) => {
  if (!string) return '';
  return string
    .split(' ')
    .map(word => word[0].toUpperCase() + word.substring(1).toLowerCase())
    .join(' ');
};
